import { appbarHeight } from "themes/constants/sizes"
import { switchButton } from "themes/default/mixins"

export const styles = {
  header: (theme) => ({
    backgroundColor: theme.palette.primary.blue,
    height: appbarHeight,
    justifyContent: "center",
    px: 0,
    "& .MuiToolbar-root": {
      px: 1.875,
    },
  }),
  menuIcon: (theme) => ({
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: theme.palette.common.white,
    flexShrink: 0,
    transition: "fill 200ms cubic- bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: "1.51429rem",
  }),
  menuButton: (theme) => ({
    mr: "1rem",
    ml: 0,
    width: 35,
    height: 35,
    backgroundColor: theme.palette.background.default,
    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },
  }),
  headerMenuItem: (theme) => ({
    height: "100%",
    px: 0,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.dark
        : theme.palette.common.white,
    "& a": {
      color:
        theme.palette.mode === "dark"
          ? theme.palette.common.dark
          : theme.palette.common.white,
      textDecoration: "none",
    },
  }),
  headerMenuItemText: (theme) => ({
    color: theme.palette.common.white,
    textTransform: "capitalize",
    px: 1.875,
    cursor: "pointer",
  }),
  headerLeft: {
    // py: 1.875,
  },
  userAvatar: {
    mr: ".15em",
    width: 28,
    height: 28,
  },
  headerRightButton: (theme) => ({
    p: 0,
    ml: 0,
    width: 30,
    height: 30,
    mr: ".25em",
    color: theme.palette.common.white,
  }),
  activeMenuItem: (theme) => ({
    "& p": {
      color: theme.palette.primary.main,
    },
    "& :before": {
      content: '""',
      left: 0,
      bottom: 1,
      position: "absolute",
      width: "100%",
      height: 5,
      backgroundColor: theme.palette.primary.main,
      borderRadius: "2rem 2rem 0 0",
    },
  }),
  headerCenterContent: {},
  headerCenter: (theme) => ({
    height: appbarHeight,
    "& a": {
      color:
        theme.palette.mode === "dark"
          ? theme.palette.common.black
          : theme.palette.common.white,
    },
  }),
  menuItem: (theme) => ({
    p: ".5rem",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : `${theme.palette.common.black}66`,
    fontSize: 14,
  }),
  tutorialSwitch: switchButton,
}
